import { Controller } from "stimulus"

// #1707: op het trainingsscherm van de tablet staat steeds hooguit één
// uitklapvenster open (vervangen, informatie, notitie). Een tik buiten het
// venster sluit het; binnen het venster blijft het open.
export default class extends Controller {
  connect() {
    this.sluitBuiten = this.sluitBuiten.bind(this)
    this.wissel = this.wissel.bind(this)
    document.addEventListener("click", this.sluitBuiten)
    this.element.addEventListener("toggle", this.wissel, true)
  }

  disconnect() {
    document.removeEventListener("click", this.sluitBuiten)
    this.element.removeEventListener("toggle", this.wissel, true)
  }

  wissel(event) {
    const geopend = event.target
    if (!geopend.matches("details.ca-popover") || !geopend.open) return

    this.element.querySelectorAll("details.ca-popover[open]").forEach((venster) => {
      if (venster !== geopend) venster.removeAttribute("open")
    })
  }

  sluitBuiten(event) {
    const binnen = event.target.closest("details.ca-popover")
    this.element.querySelectorAll("details.ca-popover[open]").forEach((venster) => {
      if (venster !== binnen) venster.removeAttribute("open")
    })
  }
}
